import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=4aa97e44"
import script from "./approval.vue?vue&type=script&lang=js"
export * from "./approval.vue?vue&type=script&lang=js"
import style0 from "./approval.vue?vue&type=style&index=0&id=4aa97e44&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports